"use client";

import Markdown from "../../utils/Markdown";
import { handleImgResponse } from "@/utils/utility";
import Link from "next/link";

export default function ServicesRelatedProducts(cluster: any) {

  return (
    <>
      <section className="md:pb-32">
        <div className="max-w-[100%] m-[40px]">
          <div className="grid grid-cols-12">
            <div className="col-span-12 lg:col-span-3 mb-8 sm:mb-2">
              <div className="lg:max-w-[250px]">
                <h4>
                  <Markdown>{cluster?.title}</Markdown>
                </h4>
                <Link href={cluster?.cta?.link || ""}>
                  <button className="btn-primary mt-4">
                    {cluster?.cta?.text}
                  </button>
                </Link>
              </div>
            </div>

            {cluster?.relatedProducts?.map((item: any, index: any) => (
              <div key={index} className="col-span-12 lg:col-span-3">
                <a
                  href={`/services/${item?.slug}`}
                  className="no-underline text-inherit hover:border-none col-span-2 xl:col-span-1"
                  key={index}
                >
                  <div
                    key={index}
                    className={` flex-grow shadow-cu h-[300px] bg-center bg-no-repeat rounded-[30px] md:w-4/5 bg-[length:90%_85%] pl-[30px] pb-[30px]`}
                    style={{
                      backgroundImage:
                        "url(" + handleImgResponse(item?.image) + ")",
                    }}
                  >
                    <div className="pt-4 bdy-txt-1 font-black w-6">
                      <Markdown>{item?.name}</Markdown>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
